'use strict';

const { Component } = require('phy');
const { hydrate } = require('@grpn/hydration');

const { getItem, setItem } = require('../../modules/support/storage-helper');
const { displayOnPage } = require('../../modules/support/display-rule-helper');

const AlertBar = require('./alert-bar');

const cookie = {
  name: 'alert_bar',
  value: 'hidden',
};

class AlertBarWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      display: false,
    };
    this.onClickClose = this.onClickClose.bind(this);
  }

  componentDidMount() {
    const { advert } = this.props;

    if (advert && advert.headerBar) {
      const display = this.getDisplay();
      const isNotDismissed = getItem(cookie.name) !== cookie.value;

      if (display && isNotDismissed) {
        this.show();
      }
    }
  }

  render() {
    const { advert } = this.props;
    const { display } = this.state;

    if (!advert || !display) {
      return null;
    }

    return AlertBar({
      advert,
      closeHandler: this.onClickClose,
    });
  }

  onClickClose() {
    setItem(cookie.name, cookie.value);
    this.setState({ display: false });
  }

  getDisplay() {
    const { advert } = this.props;

    return displayOnPage({
      advert,
      urlPath: window.location.pathname,
    });
  }

  show() {
    const {
      advert: {
        headerBar: { displayAfterSeconds },
      },
    } = this.props;

    window.setTimeout(
      () => this.setState({ display: true }),
      displayAfterSeconds ? displayAfterSeconds * 1000 : 0
    );
  }
}

module.exports = hydrate('AlertBarWrapper', AlertBarWrapper);
